// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `canvas {
  width: 150;
  height: 30;
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/app/views/learn/visualizer/visualizer.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,UAAA;EAEA,qBAAA;AAAF","sourcesContent":["canvas {\n  width: 150;\n  height: 30;\n\n  display: inline-block;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
